import db from "@/database";

export const findParesByTypeId = async (typeId) => {
  console.log("findParesByTypeId", typeId);
  return db.par.where("typeId").equals(typeId).toArray();
};

export const findOne = async (parId) => {
  console.log("findOne", parId);
  return db.par.get(parId);
};

export const findByIds = async (ids) => {
  console.log("findByIds", findByIds);
  return db.par.where("id").anyOf(ids).toArray();
};
